import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  where,
} from "firebase/firestore";
import { getPublicProfileById } from "../services/publicProfiles";

const getChatUser = (uid, userData = {}) => ({
  uid,
  username: userData.profileInfo?.username || userData.username || "",
  profilePicUrl:
    userData.profileInfo?.profilePicUrl || userData.profilePicUrl || "",
});

export async function getOrCreateDirectConversation({
  db,
  currentUserId,
  targetUserId,
}) {
  if (!db || !currentUserId || !targetUserId) {
    throw new Error("Both users are required to start a conversation.");
  }
  if (currentUserId === targetUserId) {
    throw new Error("You cannot start a conversation with yourself.");
  }

  const existingChats = await getDocs(
    query(
      collection(db, "chats"),
      where("members", "array-contains", currentUserId)
    )
  );
  const existingChat = existingChats.docs.find((chatDoc) =>
    (chatDoc.data().members || []).includes(targetUserId)
  );

  if (existingChat) return existingChat.id;

  const [currentUserSnap, targetUserData] = await Promise.all([
    getDoc(doc(db, "Users", currentUserId)),
    getPublicProfileById(targetUserId),
  ]);

  if (!currentUserSnap.exists() || !targetUserData) {
    throw new Error("The coaching account could not be found.");
  }

  const conversationId = `${currentUserId}_${targetUserId}`;
  const timestamp = serverTimestamp();

  await Promise.all([
    setDoc(
      doc(db, "chats", conversationId),
      {
        members: [currentUserId, targetUserId],
        lastMessage: "",
        timestamp,
        Users: [
          getChatUser(currentUserId, currentUserSnap.data()),
          getChatUser(targetUserId, targetUserData),
        ],
      },
      { merge: true }
    ),
    setDoc(
      doc(db, "Users", currentUserId, "chats", conversationId),
      { chatId: conversationId, timestamp },
      { merge: true }
    ),
    setDoc(
      doc(db, "Users", targetUserId, "chats", conversationId),
      { chatId: conversationId, timestamp },
      { merge: true }
    ),
  ]);

  return conversationId;
}
